import React from 'react';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section
      className="relative flex items-center justify-center bg-cover bg-center bg-no-repeat py-[164.5px] px-5 sm:px-6 xl:px-8"
      style={{
        backgroundImage: `linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0.216) 0%, rgba(0, 0, 0, 0) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('/assets/home-hero.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Content */}
      <div className="relative z-10 text-center text-white max-w-[727px] mx-auto">
        {/* Quality Premium Badge */}
        <div className="flex items-center justify-center">
          <div className="bg-[#EFEFEF] w-fit rounded-[80px] py-2 px-6">
            <h3 className="text-[#15202E] text-[12px] sm:text-[16px] leading-[15px] sm:leading-[19px] font-normal tracking-[3.2px] inter">
              {t('hero.badge')}
            </h3>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="my-4 text-[32px] sm:text-[50px] lg:text-[64px] font-normal leading-[40px] sm:leading-[60px] lg:leading-[74px] tracking-[-0.48px] libre-baskerville">
          {t('hero.heading')}
        </h1>

        {/* Subheading */}
        <p className="text-[14px] sm:text-[16px] leading-[25px] text-white font-normal inter max-w-[587px] mx-auto">
          {t('hero.subheading')}
        </p>

        {/* Buttons */}
        <div className="my-4 flex flex-col gap-4 items-center justify-center">
          <button className="bg-white text-black px-4 sm:px-8 py-2.5 sm:py-5 rounded-lg sm:rounded-[16px] font-medium inter text-[16px] sm:text-[20px] leading-[19px] sm:leading-[24px] tracking-[1.28px] hover:bg-gray-50 transition duration-300">
            {t('hero.primaryCta')}
          </button>
          <button className="border border-white text-white px-4 sm:px-8 py-2.5 sm:py-5 rounded-lg sm:rounded-[16px] font-medium inter text-[16px] sm:text-[20px] leading-[17px] sm:leading-[22px] tracking-[1.28px] hover:bg-gray-50 hover:text-black transition duration-300">
            {t('hero.secondaryCta')}
          </button>
        </div>

        {/* Social Proof */}
        <div className="flex items-center justify-center gap-3.5 sm:gap-4">
          {/* Customer Avatars */}
          <div className="flex -space-x-3">
            <div className="w-[47.61px] sm:w-[56px] h-[47.61px] sm:h-[56px] rounded-full flex items-center justify-center">
              <img src="/assets/placeholder.svg" alt="placeholder" />
            </div>
            <div className="w-[47.61px] sm:w-[56px] h-[47.61px] sm:h-[56px] rounded-full flex items-center justify-center">
              <img src="/assets/placeholder.svg" alt="placeholder" />
            </div>
            <div className="w-[47.61px] sm:w-[56px] h-[47.61px] sm:h-[56px] rounded-full flex items-center justify-center">
              <img src="/assets/placeholder.svg" alt="placeholder" />
            </div>
          </div>
          <div
            className="bg-white rounded-[80px] py-2 px-4 sm:px-6 flex items-center justify-center"
            style={{ boxShadow: '0px 79px 100px -28px #00000012' }}
          >
            <h3 className="text-[14px] sm:text-[16px] leading-[25px] font-normal inter text-[#15202E]">
              <span className="text-[#00001D] text-[17px] sm:text-[21px] leading-[32px] kanit pr-2">
                {t('hero.customersCount')}
              </span>
              {t('hero.customersJoined')}
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
